import { Badge } from '@/components/ui/badge';
import type { MapLocation } from '@/entities/dashboard';
import { LucideIcon } from 'lucide-react';

interface LocationItemProps {
  location: MapLocation;
  getIcon: (type: string) => LucideIcon;
  getColor: (type: string) => string;
}

export function LocationItem({ location, getIcon, getColor }: LocationItemProps) {
  const Icon = getIcon(location.type);

  return (
    <div className="flex items-center justify-between p-3 border rounded-lg">
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-full ${getColor(location.type)} text-white`}>
          <Icon className="w-4 h-4" />
        </div>
        <div>
          <div className="font-medium">{location.name}</div>
          <div className="text-sm text-muted-foreground">
            {location.lat.toFixed(4)}, {location.lng.toFixed(4)}
          </div>
        </div>
      </div>
      <div className="text-right">
        <Badge variant="outline" className="capitalize">
          {location.type}
        </Badge>
        {location.data.consignments && (
          <div className="text-sm text-muted-foreground mt-1">{location.data.consignments} consignments</div>
        )}
      </div>
    </div>
  );
}
